import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {
  fetchEditSurveyQuestionnairesDetails,
  fetchEditSurveySummaryDetails
} from "../../core/questionnaires.selectors";
import {RespondentModel} from "../../models/fetch-questionnaires-list.model";
import {Router} from "@angular/router";
import {
  TriggerNotificationRequest
} from 'src/app/modules/shared/core/shared.actions';
import {
  NotificationTypeKeyMap
} from 'src/app/modules/shared/constants/notification.config';
import {
  FetchEditSurveySummaryDetailsRequest
} from '../../core/questionnaires.actions';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-edit-summary',
  templateUrl: './edit-summary.component.html',
  styleUrls: ['./edit-summary.component.css']
})
export class EditSummaryComponent implements OnInit, OnDestroy {
  @Input() surveyId: string = ''
  @Input() loggedInUserRole: number = null;
  @Input() groupId: string = '';
  @Input() clientId: string = '';
  status: any;
  expandPanel: any = true;
  loading: boolean = false;
  surveyRespondentData: RespondentModel[] = [];
  surveyPendingData: RespondentModel[] = [];
  filterForm: FormGroup = new FormGroup({
    searchText: new FormControl('')
  });
  surveyDisplayColumn: any[] = [
    'name',
    'clinics',
    'groups',
    'dateOfResponding',
    'view'
  ]

  pendingDisplayColumns: any[] = [
    'name',
    'clinics',
    'groups',
    'view'
  ]

  private roleMap = {
    1: 'stanford-admin',
    2: 'organization-admin',
    3: 'coach',
  }
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private store: Store, private router: Router) {
  }


  ngOnInit(): void {
    this.fetchSummaryDetails();
    this.store.select(fetchEditSurveySummaryDetails)
      .pipe(takeUntil(this.onDestroy)).subscribe(summaryDetails => {
      this.surveyRespondentData = summaryDetails.summary.respondent;
      this.surveyPendingData = summaryDetails.summary.pending;
      this.loading = summaryDetails.loading
    })

    this.store.select(fetchEditSurveyQuestionnairesDetails)
      .pipe(takeUntil(this.onDestroy)).subscribe(data => {
      if (data?.details) {
        this.status = data.details.status;
        if (this.status.key === 3) {
          this.pendingDisplayColumns.splice(this.pendingDisplayColumns.indexOf('view'), 1);
        }
      }
    })
  }


  getClinicsAndGroupList(clinics) {
    if (clinics?.length > 0) {
      return clinics.map((item) => {
        return item.name;
      }).join(",");
    }
  }

  fetchSummaryDetails() {
    this.store.dispatch(FetchEditSurveySummaryDetailsRequest({
      payload: {
        surveyId: this.surveyId,
        ...(this.filterForm.value.searchText ? {searchText: this.filterForm.value.searchText} : {})
      }
    }))
  }

  viewSurveyDetails(surveyDetails: any) {
    if (this.loggedInUserRole === 1 && !this.groupId && !this.clientId) {
      this.router.navigate([`/stanford-admin/questionnaires/review-questionnaire-response/${surveyDetails?.userId}/${this.surveyId}`])
    } else if (this.groupId || this.clientId) {
      if (this.groupId) {
        this.router.navigate([`/${this.roleMap[this.loggedInUserRole]}/group/${this.groupId}/questionnaires/review-questionnaire-response/${surveyDetails?.userId}/${this.surveyId}`])
      } else if (this.clientId) {
        this.router.navigate([`/${this.roleMap[this.loggedInUserRole]}/organization/${this.clientId}/questionnaires/review-questionnaire-response/${surveyDetails?.userId}/${this.surveyId}`])
      }
    }
  }

  sendReminder(userData: any) {
    this.store.dispatch(TriggerNotificationRequest({
      payload: {
        surveyId: +this.surveyId,
        type: NotificationTypeKeyMap.survey,
        userId: userData.userId
      }
    }))
  }

  applyButtonClicked() {
    this.fetchSummaryDetails();
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
